/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitDocumentListByCompanyId,
    PressKitDocumentListByCompanyIdFromJSON,
    PressKitDocumentListByCompanyIdFromJSONTyped,
    PressKitDocumentListByCompanyIdToJSON,
} from './PressKitDocumentListByCompanyId';

/**
 * 
 * @export
 * @interface GetPressKitDocumentListResponse
 */
export interface GetPressKitDocumentListResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitDocumentListResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitDocumentListResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitDocumentListByCompanyId}
     * @memberof GetPressKitDocumentListResponse
     */
    data: PressKitDocumentListByCompanyId;
}

export function GetPressKitDocumentListResponseFromJSON(json: any): GetPressKitDocumentListResponse {
    return GetPressKitDocumentListResponseFromJSONTyped(json, false);
}

export function GetPressKitDocumentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitDocumentListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitDocumentListByCompanyIdFromJSON(json['data']),
    };
}

export function GetPressKitDocumentListResponseToJSON(value?: GetPressKitDocumentListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitDocumentListByCompanyIdToJSON(value.data),
    };
}

